// Module
var code = "<div class=\"security-form md-padding\">\n    <div class=\"row\">\n        <div class=\"col-sm-4\">\n            <change-password></change-password>\n        </div>\n        <div class=\"col-sm-8\">\n            <show-session></show-session>\n        </div>\n    </div>\n</div>";
// Exports
var _module_exports = code;;
var path = 'template/settings/tabs/security.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;